import axios from 'axios';
import * as endpoint from '../../../endpoint';
import * as actionTypes from '../../../actionTypes';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * デバイス認証設定取得APIを呼び出す
 * TODO: テスト追加
 * TODO: 異常系のエラーハンドリングを再考する
 *
 * @param {string} apiToken - API認証トークン
 * @returns
 */
const getDeviceAuthSettings = apiToken => dispatch => {
  consolelog('[API CALL] getDeviceAuthSetting()');
  configureAxiosForJSON(apiToken);
  const url = endpoint.API_GET_DEVICE_AUTH_SETTINGS;
  const { cancelToken, cancelTokenKey } = createCancelToken(
    'getDeviceAuthSetting',
  );

  const axiosParams = {
    cancelToken,
  };

  return axios
    .get(url, axiosParams)
    .then(res => {
      dispatch({
        type: actionTypes.SUCCESS_API_GET_DEVICE_AUTH_SETTINGS,
        payload: res.data,
      });
    })
    .catch(thrown => {
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch);
      }
    })
    .finally(() => delCancelToken(cancelTokenKey));
};

export default getDeviceAuthSettings;
